import styled from 'styled-components'

const DebateSliderStyle = styled.div.attrs({})`
    section {
        margin-bottom:var(--sp8x);
    }

    .my-slider-progress {
        background:#f2f2f2;
    }
    
    .my-slider-progress-bar {
        background-color: var(--purple);
        height: 3px;
        transition: width 400ms ease;
        width: 0;
        border-radius: 20px;
    }

    .splide--slide  {
        margin:var(--sp8x) 0 0;
        padding-bottom: var(--sp3x);
        
        &:before {
            content:'';
            position:absolute ;
            top:0;
            right:-1px;
            width: 20vh;
            height: 100%;
            background: linear-gradient(90deg, rgba(255,255,255,0.09007352941176472) 0%, rgba(255,255,255,1) 100%);
            z-index: 2;
            pointer-events: none;
        }
        
        .splide__arrow--prev {
            position: absolute;
            top:50%;
            left:0;
            width:var(--sp5x);
            height:var(--sp5x);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 5;
            border-radius:50%;
            border:2px solid var(--purple);
            background-color: var(--white);
            cursor: pointer;
            transform: translateY(-50%);
            transition:var(--trTime);
            opacity: 0.5;

            &:hover {
                opacity: 1;
            }

            &:disabled   {
                opacity: 0;
                pointer-events: none;
            }
            
            i {
                color:var(--purple);
                transform:rotate(180deg);
                font-size:14px ;
                font-weight: bold;
            }
        }

        .splide__arrow--next {
            position: absolute;
            top:50%;
            right:0;
            width:var(--sp5x);
            height:var(--sp5x);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 5;
            border-radius:50%;
            border:2px solid var(--purple);
            background-color: var(--white);
            cursor: pointer;
            transition: var(--trTime);
            transform: translateY(-50%);
            opacity: .4;
            
            &:hover {
                opacity: 1;
            }

            &:disabled  {
                opacity: 0;
                pointer-events: none;
            }

            i {
                color:var(--purple);
                font-weight:bold;
                font-size:14px ;
            }
        }
        
        .splide__list {
            height: 100%;
            align-items:stretch;

            .splide__slide  {
                height: auto;
                width: var(--sp52x);

                &:nth-child(1){
                    width: var(--sp24x);
                }

                & > * {
                    height: 100%;
                }   
            }
        }
    }

    @media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
        section {
            margin-bottom:var(--sp4x);
        }

        .my-slider-progress {
            display:none;
        }

        .splide--slide {
            margin:var(--sp4x) 0 0;

            &:before {
                width: 15vh;
            }
            
            .splide__list {

                .splide__slide {
                    width: var(--sp43x);

                    &:nth-child(1){
                        width: var(--sp10x);
                    }
                }
            }
            .splide__arrow--prev,
            .splide__arrow--next {
                display: none;
            }
        }
    }
`
export default DebateSliderStyle
